import {
  ControlField,
  IControlField,
  IControlField2,
  IFieldResponse
} from './control-field.base';

export interface ISelectOption {
  label: string;
  value: string;
  icon?: string;
}

export interface IMultiSelectControlField extends IControlField {
  values: string[];
  field_options?: ISelectOption[];
  payload_dtype: string[];
  value_dtype: string;
  default_value: string[];
  response_dtype: string[];
}

export interface IMultiSelectControlField2 extends IControlField2 {
  options?: any;
  values?: ISelectOption[];
  isMultiple?: boolean;
  limit?: number;
}

export class MultiSelectControlField
  extends ControlField
  implements IMultiSelectControlField
{
  values: string[];

  field_options?: ISelectOption[];

  payload_dtype: string[];

  value_dtype: string;

  default_value: string[];

  response_dtype: string[];

  constructor(field: IMultiSelectControlField) {
    super(field);
    this.payload_dtype = field.payload_dtype;
    this.value_dtype = field.value_dtype;
    this.default_value = field.default_value;
    this.response_dtype = field.response_dtype;
    this.field_options = field.values.map((e) => ({ label: e, value: e }));
    if (typeof field.default_value === 'string') {
      this.default_value =
        field.default_value === '' ? [] : field.values.slice();
    } else {
      this.default_value = field.default_value || [];
    }
  }
}

export function toSelectField(
  field: IFieldResponse,
  isMultiple = false
): IMultiSelectControlField2 {
  let defaultValue = field.default_value as ISelectOption[];
  if (typeof field.default_value === 'string') {
    if (field.default_value.toLowerCase() === 'all') {
      defaultValue = (field.values as any[]).map<ISelectOption>((value) => {
        if (typeof value === 'object' && value.label) {
          return value;
        }
        if (typeof value === 'string') {
          return { label: value, value };
        }
        return value;
      });
    } else if (field.default_value === '') {
      defaultValue = [];
    } else {
      const matchingField = (field.values as unknown[]).find((value) => {
        const option = value as ISelectOption;
        if (typeof option === 'object' && (option.label || option.value)) {
          return (
            option.label === field.default_value ||
            option.value === field.default_value
          );
        }
        return typeof value === 'string' && value === field.default_value;
      });
      if (matchingField) {
        if (
          typeof matchingField === 'object' &&
          (matchingField as ISelectOption).label &&
          (matchingField as ISelectOption).value
        ) {
          defaultValue = [matchingField as ISelectOption];
        }
        if (typeof matchingField === 'string') {
          defaultValue = [
            { label: matchingField, value: matchingField } as ISelectOption
          ];
        }
      } else {
        defaultValue = [
          { label: matchingField, value: matchingField } as ISelectOption
        ];
      }
    }
  }
  return {
    id: field.id,
    control_type: field.control_type,
    name: field.name,
    alias: field.alias,
    is_mandatory: field.is_mandatory,
    is_active: field.is_active,
    is_disabled: field.is_disabled,
    is_visible: field.is_visible,
    placement_order: field.placement_order,
    helper_text: field.helper_text || '',
    is_hierarchical: field.is_hierarchical,
    default_value: defaultValue,
    values: (field.values as unknown[]).map<ISelectOption>((value) => {
      if (typeof value === 'object') {
        return value as ISelectOption;
      }
      return {
        label: value as string,
        value: value as string
      };
    }),
    isMultiple: isMultiple || false,
    limit: field.limit || null,
    section: field.section || '',
    dtype: field.dtype,
    is_auto_fill: field.is_auto_fill,
    planner_flag: field.planner_flag,
    info_details: field.info_details,
    is_info_enable: field.is_info_enable
  };
}
